var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsernamicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81273 4C9.81273 4.74592 9.51641 5.46129 8.98896 5.98874C8.46152 6.51618 7.74615 6.8125 7.00023 6.8125C6.25431 6.8125 5.53893 6.51618 5.01149 5.98874C4.48404 5.46129 4.18773 4.74592 4.18773 4C4.18773 3.25408 4.48404 2.53871 5.01149 2.01126C5.53893 1.48382 6.25431 1.1875 7.00023 1.1875C7.74615 1.1875 8.46152 1.48382 8.98896 2.01126C9.51641 2.53871 9.81273 3.25408 9.81273 4ZM1.37598 14.5885C1.40008 13.1128 2.00323 11.7056 3.05536 10.6705C4.10749 9.63545 5.52429 9.05535 7.00023 9.05535C8.47616 9.05535 9.89296 9.63545 10.9451 10.6705C11.9972 11.7056 12.6004 13.1128 12.6245 14.5885C10.86 15.3976 8.94134 15.8151 7.00023 15.8125C4.99323 15.8125 3.08823 15.3745 1.37598 14.5885Z",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsernamicon);
export default __webpack_public_path__ + "static/media/usernamicon.da939319c5e0095e4f049209af26152b.svg";
export { ForwardRef as ReactComponent };